import $ from 'jquery';

const checkoutStepper = () => {
    const $stepperContainer = $('.mi-checkout-stepper');
    if (!$stepperContainer.length) return;

    const setStep = (stepNumber) => {
        $('.mi-step').each(function (index) {
            const $step = $(this);
            const num = index + 1;
            const $circle = $step.find('.mi-step-circle');

            if (num < stepNumber) {
                $step.addClass('is-completed').removeClass('is-active');
                if ($circle.length && !$circle.find('svg').length) {
                    $circle.html(`<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.66667 0C2.99333 0 0 2.99333 0 6.66667C0 10.34 2.99333 13.3333 6.66667 13.3333C10.34 13.3333 13.3333 10.34 13.3333 6.66667C13.3333 2.99333 10.34 0 6.66667 0ZM9.85333 5.13333L6.07333 8.91333C5.98 9.00667 5.85333 9.06 5.72 9.06C5.58667 9.06 5.46 9.00667 5.36667 8.91333L3.48 7.02667C3.28667 6.83333 3.28667 6.51333 3.48 6.32C3.67333 6.12667 3.99333 6.12667 4.18667 6.32L5.72 7.85333L9.14667 4.42667C9.34 4.23333 9.66 4.23333 9.85333 4.42667C10.0467 4.62 10.0467 4.93333 9.85333 5.13333Z" fill="white"/>
                                        </svg>`);
                }
            } else if (num === stepNumber) {
                $step.addClass('is-active').removeClass('is-completed');
                if ($circle.length) {
                    $circle.html('<span class="mi-step-number">' + num + '</span>');
                }
            } else {
                $step.removeClass('is-active is-completed');
                if ($circle.length) {
                    $circle.html('<span class="mi-step-number">' + num + '</span>');
                }
            }
        });
    };

    const $btnNext3 = $('#btn-next-step-3');
    if ($btnNext3.length) $btnNext3.on('click', () => setStep(3));

    const $btnPrev2 = $('#btn-prev-step-2');
    if ($btnPrev2.length) $btnPrev2.on('click', () => setStep(2));

    const $btnEditGegevens = $('#btn-edit-gegevens');
    if ($btnEditGegevens.length) $btnEditGegevens.on('click', () => setStep(2));

    const $btnPrev3 = $('#btn-prev-step-3');
    if ($btnPrev3.length) $btnPrev3.on('click', () => setStep(3));
}

$(function() {
    try {
        checkoutStepper();
    } catch (error) {
        console.warn(error);
    }
});
